import { BRIGHT_GREY, STORM_GREY } from "../../../constants/colors";

const footerBackgroundColor = BRIGHT_GREY;
const subfooterBackgroundColor = STORM_GREY;
export const fallbackValues = {
  footerBackgroundColor,
  subfooterBackgroundColor
};
